document.querySelectorAll('.button, .btn').forEach(button => {
  button.addEventListener('mouseenter', function(e) {
    const rect = this.getBoundingClientRect();
    const wave = this.querySelector('.wave');
    
    if (!wave) {
      const span = document.createElement('span');
      span.classList.add('wave');
      span.style.position = 'absolute';
      span.style.bottom = '0';
      span.style.left = `${e.offsetX}px`;
      span.style.width = '100%';
      span.style.height = '0';
      span.style.backgroundColor = '#2ecc71';
      span.style.borderRadius = '50% 50% 0 0 / 20% 20% 0 0';
      span.style.transformOrigin = 'bottom';
      span.style.transform = 'scaleY(0)';
      span.style.transition = 'transform 0.6s cubic-bezier(0.65, 0, 0.35, 1)';
      span.style.zIndex = '-1';
      this.appendChild(span);

      requestAnimationFrame(() => {
        span.style.transform = 'scaleY(1)';
      });

      setTimeout(() => span.remove(), 700);
    }
  });
});
